import { ChildEventProps, SALES_STATUS } from '../../../../types';
import { eventIsOnSale } from '../../../../utils';

export const shouldShowMoreOptions = (
    childEventsOnSlider: ChildEventProps[],
    isTimeEntryEnable?: boolean,
) => {
    const slicedEventDates = isTimeEntryEnable ? 4 : 5;
    const availableFollowingEvents = childEventsOnSlider
        .slice(slicedEventDates)
        .filter(
            (event: ChildEventProps) =>
                eventIsOnSale(event) ||
                event?.sales_status == SALES_STATUS.DEFAULT,
        );
    return (
        childEventsOnSlider.length > slicedEventDates &&
        availableFollowingEvents.length > 0
    );
};
